const _sfc_main = {
  name: "HeartFilled"
};
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  fill: "currentColor",
  d: "M694.0444448 87.22962987c167.57191147 0 303.40740693 135.83549653 303.40740693 303.40740693 0 218.9691264-151.46097813 396.47762987-454.38293333 532.5406816a75.85185173 75.85185173 0 0 1-62.15300693 0C178.0091264 787.11466667 26.54814827 609.6061632 26.54814827 390.6370368 26.54814827 223.0651264 162.3836448 87.22962987 329.9555552 87.22962987c68.31217813 0 131.34506667 22.57351147 182.05961493 60.6814816A301.89037013 301.89037013 0 0 1 694.0444448 87.22962987z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "heart-filled.vue"]]);
